import React, { FC } from "react";
import StatusTag from "./status-tag";
import {useTranslation} from "react-i18next";

type StatusTagProps = {
    text?: string;
    className?: string;
};

const OccupiedStatusTag: FC<StatusTagProps> = ({ text, className }) => {
    const { t } = useTranslation();
    return (
        <StatusTag status="occupied" text={text || t("status.occupied")} className={className} />
    );
};


const VacantStatusTag: FC<StatusTagProps> = ({ text, className }) => {
    const { t } = useTranslation();
    return (
        <StatusTag status="vacant" text={text || t("status.vacant")} className={className} />
    );
};


const BookedStatusTag: FC<StatusTagProps> = ({ text, className }) => {
    const { t } = useTranslation();
    return (
        <StatusTag status="booked" text={text || t("status.booked")} className={className} />
    );
};

const RentedStatusTag: FC<StatusTagProps> = ({ text, className }) => {
    const { t } = useTranslation();
    return (
        <StatusTag status="rented" text={text || t("status.rented")} className={className} />
    );
};

const OtherStatusTag: FC<StatusTagProps> = ({ text, className }) => {
    const { t } = useTranslation();
    return (
        <StatusTag status="other" text={text || t("status.other")} className={className} />
    );
};

export { OccupiedStatusTag, VacantStatusTag, OtherStatusTag, BookedStatusTag, RentedStatusTag };
